import React from 'react'
import { Card } from 'antd'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import LoginForm from './forms/LoginForm'
import { history } from '../../utils/history'
import { loginUser, Profile } from '../../reducers/user/userActions'
import { TELEPHONE_SURVEYS_OPERATOR_PATH, USER_ROLE } from '../../utils/enums'

const LoginPage = () => {
	const dispatch = useDispatch()
	const { t } = useTranslation('components')

	const getRedirectPath = (profile: Profile | null) => {
		// Ak sa pouzivatel na login dostal z chraneneho odkazu (napr. z e-mailu),
		// po prihlaseni ho vratime na povodnu cielovu stranku.
		const params = new URLSearchParams(history.location.search)
		const redirect = params.get('redirect')
		if (redirect && redirect.startsWith('/')) {
			return redirect
		}
		if (profile?.role === USER_ROLE.PHONE_OPERATOR) {
			return TELEPHONE_SURVEYS_OPERATOR_PATH
		}
		return t('paths:dashboard|path')
	}

	const handleSubmit = async (values: any) => {
		await dispatch(loginUser(values.email, values.password, (profile) => history.push(getRedirectPath(profile))))
	}

	return (
		<div className={ 'flex-container primary' }>
			<Card className={ 'secondary' } style={ { width: '400px', border: 'none' } }>
				<div className={ 'login-logo' } />
				<LoginForm onSubmit={ handleSubmit } />
			</Card>
		</div>
	)
}

LoginPage.propTypes = {}

export default LoginPage
